import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, ModalController, LoadingController, ToastController } from 'ionic-angular';
import { OrdersCoServices } from '../../services';
import { Globals } from '../../../../globals';
import { PrintServices } from '../../../services/printServices';
import { OrdersSelectPage } from '../../orders-select/orders-select';
import { OrdersUpDelPage } from '../../orders-updel/orders-updel';
import { OrdersPositionsPage } from '../../orders-positions/orders-positions';
import { BlockScreenPage } from '../../../components/block-screen/block-screen';
import { TranslateService } from '@ngx-translate/core';
import { SelectedPersonsPage } from '../../../components/selected-persons/selected-persons';
import { TPVServices } from '../../../tpv/services';
import { AnalyticsServices } from '../../../services/analyticsServices';
import { PopupSelectPayment } from '../../../components/popups/popup-select-payment/popup-select-payment';
import * as moment from 'moment';
import { getCurrencySymbol } from '@angular/common';
import { PrintTicketOrETicket } from '../../../components/popups/print-ticket-or-eticket/print-ticket-or-eticket';
import { HttpClient, HttpParams } from '@angular/common/http';
import { PopupSelectCustomer } from '../../../components/popups/popup-select-customer/popup-select-customer';
import * as firebase from 'firebase';


/**
 * Generated class for the TpvTicketPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-orders-table-buttons',
  templateUrl: 'orders-table-buttons.html',
})
export class OrdersTableButtonsPage {
  qr_link: any;
  public firestore;


  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public ordersCoServices: OrdersCoServices,
    public globals: Globals,
    private printServices: PrintServices,
    public alertCtrl: AlertController,
    public translate: TranslateService,
    private modalCtrl: ModalController,
    public loadingCtrl: LoadingController,
    public tpvServices: TPVServices,
    public analyticsServices: AnalyticsServices,
    public http: HttpClient,
    private toastCtrl: ToastController,
  ) {
    this.firestore = firebase.firestore();
  }

  ionViewDidLoad() {

  }

  async print() {

    this.globals.GAtrackView('Orders', 'Orders - Orders - Print', this.globals.restaurant.email, 'View', 'Print orders', 'Orders', '');

    await this.ordersCoServices.getOrdersAllPrint(this.globals.restaurant_uid, this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index].UID);

    if (this.globals.restaurant.printer_type == 'native') {
      this.ordersCoServices.kitchen_filter = 'orders';
      this.globals.print_content = document.getElementById('print_order');

      this.ordersCoServices.orders_print = 'all';
      var interval = setInterval(() => {
        this.printServices.printNow('print_order');
        clearInterval(interval);
      }, 1000);
    } else {
      this.printServices.prepareOrderKitchen('all', this.ordersCoServices.listall_print, this.ordersCoServices.listall_print, this.globals.restaurant.printer_type, 'orders');
    }

  }

  openSelect() {
    this.ordersCoServices.update_state = false;
    this.navCtrl.push(OrdersSelectPage);
  }



  openMod() {
    this.navCtrl.push(OrdersUpDelPage, {
      update: true
    });
  }

  openDelete() {
    this.navCtrl.push(OrdersUpDelPage, {
      update: false
    });
  }

  openModPositions() {
    this.navCtrl.push(OrdersPositionsPage);

  }

  openPersons() {
    /*this.navCtrl.push(OrdersSelectSelectedPersonsPage);*/
    let profileModal = this.modalCtrl.create(SelectedPersonsPage, {
      origin: 'orders',
      update: true
    });
    profileModal.present();
  }

  async cancelTicket() {
    const confirm = this.alertCtrl.create({
      title: this.translate.instant('instant-eliminar-ticket'),
      message: this.translate.instant('instant-seguro-quieres-eliminar-contenido-ticket'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          handler: () => {

          }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            this.globals.GAtrackView('Orders', 'Orders - Delete', this.globals.restaurant.email, 'Delete', 'Delete order', 'Orders', this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index].UID);
            //data set waiter activity
            var extra_activity: any =
            {
              'type': 'cancel',
              'value': 1,
              'source': 'orders',

            };
            this.globals.dataSet('waiter_activity', this.globals.waiter_uid, '', JSON.stringify(extra_activity), '');
            this.deleteTicket();
          }
        }
      ]
    });
    confirm.present();
  }

  async deleteTicket() {
    var table_tmp = this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index];
    //delete orders
    await this.ordersCoServices.deleteOders(this.globals.restaurant_uid, this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index].UID);
    //delete true tpvtable
    this.deleteFromTables();
    //insert _data analytics WAITER
    let _element = [];
    _element.push("TICKET")
    var waiter = {
      'uid': this.globals.restaurant_uid,
      'waiter': this.globals.waiter,
      'elements': _element,
      'date': new Date(),
      'type': "waiter",
      'type_type': "DELETE",
    };
    this.analyticsServices.sendWaiter(waiter);
    //insert _data analytics cancel_tickets
    if (table_tmp.ticket.number) {
      var cancel_table_ticket = {
        'uid': this.globals.restaurant_uid,
        'number': table_tmp.ticket.number,//numero ticket cancelado
        'cash': table_tmp.cash_static,//caja que dio el numero ticket
        'cash_uid': table_tmp.cash_uid,//uid de la caja
        'type': 'table',//table o tk (sitio donde se ejecuto)
        'amount': this.ordersCoServices.totalTicketSelected(this.ordersCoServices.selected_table_tpv_index),//total mesa
        'name': table_tmp.name,// nombre mesa/tk
        'waiter': this.globals.waiter,//camrero que ejecuto accion
        'app_section': 'APP2',//app donde se ejecuto
        'date': new Date()
      }
      this.analyticsServices.cancelTableTicket(cancel_table_ticket);
    }
  }

  deleteFromTables() {
    this.ordersCoServices.table_tmp = this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index];

    for (let list of this.globals.objectToArray(this.ordersCoServices.table_tmp.ticket.list)) {
      list.count = false;
      list.delete = true;
    }

    this.ordersCoServices.afs.collection('tables').doc(this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index].UID).update({
      ticket: {
        amount: this.ordersCoServices.table_tmp.ticket.amount,
        payment: this.ordersCoServices.table_tmp.ticket.payment,
        payment_type: this.ordersCoServices.table_tmp.ticket.payment_type,
        date: this.ordersCoServices.table_tmp.ticket.date,
        number: this.ordersCoServices.table_tmp.ticket.number,
        waiter: this.ordersCoServices.table_tmp.ticket.waiter,
        waiter_uid: this.ordersCoServices.table_tmp.ticket.waiter_uid,
        list: this.ordersCoServices.table_tmp.ticket.list,
        updated_at: new Date(),
        created_at: this.ordersCoServices.table_tmp.ticket.created_at,
        tip: this.ordersCoServices.table_tmp.ticket.tip || 0,
      },
      state: 'open',
      customer: {}
    });
  }

  block() {
    this.navCtrl.push(BlockScreenPage, {
      type: 'orders',
    });
  }


  async printOrETicket(customer = "") {
    try {
      if (customer == "") {
        customer = this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].customer;
      }
      //Comprovamos si el ticket digital esta activado
      if (this.globals.restaurant.tickets.ticket_digital || this.globals.restaurant.tickets.ticket_digital == undefined) {
        let profileModal = this.modalCtrl.create(PrintTicketOrETicket,
          {
            title: this.translate.instant('general-ticket'),
            customer: customer,
            table: 'tpv',

          });
        profileModal.onDidDismiss(async data => {
          if (data != undefined) {
            if (data == "printTicket") {
              this.printTicket();
            } else if (data == "eTicket") {
              if (this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].customer.email != undefined) {

                let url_mctpay = await this.createMctPayCharge();




                await this.tpvServices.getTicketNumber(this.globals.restaurant_uid, this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].cash_uid)


                this.eTicket(
                  this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].ticket,
                  this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].customer,
                  url_mctpay, //link
                  this.tpvServices.totalTicketSelectedNoTax(this.tpvServices.selected_table_tpv_index, this.globals.RESTAURANT_TAX),
                  "mesa");
                //notificamos al usuario de que el ticket se envio
                let toast = this.toastCtrl.create({
                  message: this.translate.instant('eticket-ticket-digital-enviado-correctamente'),
                  duration: 3000,
                  position: 'bottom'
                });
                toast.present();

              } else {

                let profileModalPopup = await this.modalCtrl.create(PopupSelectCustomer,
                  {
                    title: this.translate.instant('general-selecciona-cliente'),
                  });
                profileModalPopup.onDidDismiss(async data => {
                  if (data != undefined) {
                    this.ordersCoServices.tableUpdateCustomer(data);
                    this.printOrETicket(data);

                  } else {
                    this.printOrETicket();
                  }

                });

                profileModalPopup.present();



              }

            } else if (data == "editCustomer") {


              let profileModalPopup = await this.modalCtrl.create(PopupSelectCustomer,
                {
                  title: this.translate.instant('general-selecciona-cliente'),
                });
              profileModalPopup.onDidDismiss(async data => {
                if (data != undefined) {
                  this.ordersCoServices.tableUpdateCustomer(data);
                  this.printOrETicket(data);

                } else {
                  this.printOrETicket();
                }

              });

              profileModalPopup.present();
            }


          } else {

          }
        });

        profileModal.present();
      } else {
        this.printTicket();
      }
    } catch (error) {
      //notificamos al usuario de que el ticket no se puedo enviar correctamente
      let toast = this.toastCtrl.create({
        message: this.translate.instant('eticket-error-al-enviar-ticket-digital'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

  async createMctPayCharge() {
    //Recuperamos la url del mct_pay_web, para el qr
    try {
      const params = new HttpParams()
        .set('public_key', this.globals.public_key)
        .set('table_uid', this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index].UID);

      const url_mctpay = await this.http.post(this.globals.analytics_path + 'mctwebpay/create_mct_pay_charge', params, {}).toPromise()
      return url_mctpay['url_mct_pay_charge'];
    } catch (error) {
      return "";
    }

  }

  eTicket(ticket, customer, mct_pay_charge, subtotal, type) {
    //tener en cuenta que el email y otros datos si viene de deliverecto no son el customer_name y etc

    var _date = '';
    if (ticket.date.seconds) {
      _date = moment(new Date(this.globals.timestampToDate(ticket.date))).format('YYYY/MM/DD HH:mm');
    } else {
      _date = moment(ticket.date).format('YYYY/MM/DD HH:mm');
    }

    let _email = {
      'UID_RESTAURANT': this.globals.restaurant_uid,
      'type': 'eticket_mctpay',
      'customer_name': this.globals.ifVarEmpty(customer.name),
      'customer_email': this.globals.ifVarEmpty(customer.email),
      'customer_phone': this.globals.ifVarEmpty(customer.phone),
      'takeaway_type': type,
      'ticket_number': ticket.number,
      'ticket_list': ticket.list,
      'ticket_date': _date,
      'ticket_currency': getCurrencySymbol(this.globals.user_currency, 'narrow', 'es'),
      'ticket_subtotal': subtotal,
      'ticket_total': this.tpvServices.totalTicketSelected(this.tpvServices.selected_table_tpv_index),
      'ticket_tax_name': this.globals.user_tax_name,
      'ticket_tax': this.globals.RESTAURANT_TAX,
      'restaurant_company': this.globals.restaurant.company,
      'restaurant_address': this.globals.restaurant.address,
      'restaurant_email': this.globals.restaurant.email,
      'restaurant_phone': this.globals.restaurant.phone,
      'restaurant_logo': this.getImageUrl(this.globals.restaurant.logo), //this.restaurant.logo
      'order_status': "",
      'mct_pay_charge': mct_pay_charge
    }


    this.firestore.collection('_emails').add(_email);
  }

  getImageUrl(img_url) {
    if (img_url != '' && img_url != undefined) {
      img_url = 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/' + img_url.replace('logo/', 'logo%2F') + '?alt=media';
      return img_url;
    } else {
      return '';
    }

  }

  async printTicket() {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('instant-imprimiendo')
    });
    loadingPopup.present();
    //loader general
    //this.globals.GAtrackView('TPV', 'TPV - Ticket - Print', this.globals.restaurant.email, 'View', 'Print TPV ticket ', 'TPV', '');
    //get ticket number
    if (this.globals.connection) {
      await this.tpvServices.getTicketNumber(this.globals.restaurant_uid, this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].cash_uid)
    } else {
      await this.tpvServices.getTicketNumberOffline();
    }

    if (this.globals.restaurant.printer_type == 'native') {
      this.globals.print_content = document.getElementById('print_list_ticket_normal');
      this.tpvServices.ticket_print = 'normal';
      //interval
      var interval_native = setInterval(() => {
        this.printServices.printNow('print_list_ticket_normal');
        this.tpvServices.deleteKeyboard();
        clearInterval(interval_native);
        //Acaba loader general
        loadingPopup.dismiss();
      }, 3000);
    } else {
      var interval_services = setInterval(() => {
        this.printServices.prepareTicket(this.tpvServices.listSelectedTicket('name', this.globals.objectToArray(this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].ticket.list))[0]
          , this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].ticket.date.toDate()
          , this.tpvServices.totalTicketSelectedNoTax(this.tpvServices.selected_table_tpv_index, this.globals.RESTAURANT_TAX)
          , this.tpvServices.totalTicketSelected(this.tpvServices.selected_table_tpv_index)
          , this.tpvServices.calculateIva(this.tpvServices.totalTicketSelected(this.tpvServices.selected_table_tpv_index), this.tpvServices.totalTicketSelectedNoTax(this.tpvServices.selected_table_tpv_index, this.globals.RESTAURANT_TAX), this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].ticket)
          , this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].ticket.waiter
          , this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].room
          , this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].name
          , this.globals.restaurant.tickets.footer
          , 'tpv'
          , this.tpvServices.ticket_num_return
          , this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].ticket
          , this.globals.restaurant.printer_type
          , false
          , this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].ticket.notes || '');
        //Acaba loader general
        loadingPopup.dismiss();
        clearInterval(interval_services);
      }, 3000);
    }
  }

  pay() {
    this.tpvServices.is_in_order = true;
    this.tpvServices.deleteKeyboard();
    //this.navCtrl.push(TpvTicketSelectedPayPage);
    let profileModal = this.modalCtrl.create(PopupSelectPayment,
      {
        table: this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index],
        origin: 'orders'

      });
    profileModal.onDidDismiss(data => {
      if (data) {
        this.navCtrl.pop();
      }
    });
    profileModal.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/orders/orders-table/orders-table-buttons/orders-table-buttons.ts